module.exports = __webpack_public_path__ + "img/01.33a658fc.jpg";